import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { blogsRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'
import { routePaths } from '../paths'
const BlogsApp = () => import('@/pmd/pages/blogs/BlogsApp.vue')

export const blogsRoutes: RouteConfig[] = [
  {
    path: routePaths.blogs,
    name: blogsRouteNames.default,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.Blogs] },
  },
  {
    path: routePaths.blogsList,
    name: blogsRouteNames.list,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: false,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogNew,
    name: blogsRouteNames.new,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: false,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogSetting,
    name: blogsRouteNames.blogSettings,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: false,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogImport,
    name: blogsRouteNames.blogImport,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: true,
      hideSideBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogCsvImport,
    name: blogsRouteNames.blogCsvImport,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: true,
      hideSideBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogCsvImportId,
    name: blogsRouteNames.blogCsvImportId,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: true,
      hideSideBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogImportId,
    name: blogsRouteNames.blogImportId,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: true,
      hideSideBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogCsvPostEditor,
    name: blogsRouteNames.blogCsvPostEditor,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: true,
      hideSideBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogsSettings,
    name: blogsRouteNames.settings,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: false,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogsPostEdit,
    name: blogsRouteNames.edit,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogsPostSettings,
    name: blogsRouteNames.postSettings,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogsPostPreview,
    name: blogsRouteNames.postPreview,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogsPostVersions,
    name: blogsRouteNames.postVersions,
    component: BlogsApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Blogs],
    },
  },
  {
    path: routePaths.blogsInvalidRoutes.blogsAuthors,
    name: blogsRouteNames.authors,
    redirect: routePaths.blogsSettings,
  },
  {
    path: routePaths.blogsInvalidRoutes.blogsAuthorsEdit,
    name: blogsRouteNames.authorsEdit,
    redirect: routePaths.blogsSettings,
  },
  {
    path: routePaths.blogsInvalidRoutes.blogsCategories,
    name: blogsRouteNames.categories,
    redirect: routePaths.blogsSettings,
  },
  {
    path: routePaths.blogsInvalidRoutes.blogsCategoriesEdit,
    name: blogsRouteNames.categoriesEdit,
    redirect: routePaths.blogsSettings,
  },
  {
    path: routePaths.blogsInvalidRoutes.blogPost,
    name: blogsRouteNames.post,
    redirect: routePaths.blogs,
  },
  {
    path: routePaths.blogsInvalidRoutes.blogPostWithId,
    name: blogsRouteNames.postDetails,
    redirect: routePaths.blogsPostEdit,
  },
  {
    path: 'blogs/*',
    redirect: routePaths.blogs,
  },
]
